interface OddBallProps {
  result: string;
}
const OddBall: React.FC<OddBallProps> = ({ result }) => {
  return (
    <span className="qrResultGameAboutTxt txtBiggest txtColorRed">
      {result}
    </span>
  );
};

export default OddBall;
